module.exports = __webpack_public_path__ + "img/lnb_03.2c4dcf0f.png";